import React, { Component } from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import { isBronPast, isBronActive } from "../Utils/Functions";

export default class Model extends Component {
  constructor(props) {
    super(props);
  }

  isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  render() {
    const { model, id } = this.props;
    let new_id =
      id.substring(0, 3) === "id_" ? id.substring(3, id.length) : id;
      console.log(model)
    if (model?.nice_url && model.nice_url !== "") {
      new_id = model.nice_url;
    }
    if (model) {
      const isBronActiveVar = isBronActive(model);
      const isBronPastVar = isBronPast(model);
      return (
        <div className="Model">
          <Link to={`/${new_id}`}>
            <div className="Model--image">
              {isBronActiveVar ? (
                <div className="Model--reserved">
                  Broneeritud
                  {model.broneeringu_algus && model?.broneeringu_lopp && (
                    <span>
                      {model.broneeringu_algus} - {model?.broneeringu_lopp}
                    </span>
                  )}
                </div>
              ) : isBronPastVar ? (
                <>
                  <div className="Model--futureBron">
                    Broneeritud ajavahemikul {model.broneeringu_algus} -
                    {model?.broneeringu_lopp}
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="Model--price">
                <span className="Model--price__info">Kuumakse</span>
                <span className="Model--price__content"> {model?.price} €</span>
              </div>
              <img src={model?.gallery[0]?.sizes?.medium} alt={model?.title} />
            </div>
            <div className="Model--info">
              <div className="Model--name">
                <h3>
                  <span className="model">
                    {model?.make?.label} {model?.model}
                  </span>
                </h3>
                <div className="Model--features">
                  {model?.additional_feature ? (
                    <>
                      <span>{model?.additional_feature}</span>{" "}
                    </>
                  ) : (
                    ""
                  )}
                  {model.engine ? (
                    <>
                      <span>{model.engine}</span>{" "}
                    </>
                  ) : (
                    ""
                  )}
                  <span className="uppercase">{model.transmission}</span>{" "}
                  <span className="uppercase">{model.fuel}</span>
                </div>
              </div>
              <button className="button button--primary">
                VAATA PAKKUMIST
              </button>
            </div>{" "}
          </Link>
        </div>
      );
    } else {
      return "";
    }
  }
}
